// ── Central project configuration ────────────────────────────────────
// To add a new project, add an object below with all fields filled in.
// The MyWork slide, detail page, and route are all generated automatically.
// Or use the admin panel at /admin to edit visually.

const PROJECTS = [
  {
    "id": "robbie-williams",
    "title": "ROBBIE WILLIAMS",
    "videoPlaybackId": "8WQkuM4wsv7he3N42rzpMayKmjMq3o02JQb8VyCadUHM",
    "videoTitle": "ROBBIE WILLIAMS",
    "detailHeading": "ROBBIE WILLIAMS SHOW",
    "paragraphs": [
      "On the 6th June 2025, I worked alongside Robbie Williams' personal videographer to capture videography for a social media reel during the London stop of his tour.",
      "My responsibility was to deliver clean, dynamic coverage that aligned precisely with a fixed setlist.",
      "Working within the constraints of a live stadium environment, the shoot demanded tight timing, rapid repositioning and disciplined framing to ensure each moment could be translated effectively into short form social content."
    ],
    "images": [
      "/images/Robbie-16x9/JJG00147.jpg",
      "/images/Robbie-16x9/12112.jpg",
      "/images/Robbie-16x9/JJG00073-3.webp",
      "/images/Robbie-16x9/JJG00077.webp",
      "/images/Robbie-16x9/JJG00311-3.jpg",
      "/images/Robbie-16x9/JJG00324.jpg",
      "/images/Robbie-16x9/JJG00374.webp",
      "/images/Robbie-16x9/JJG00436.jpg"
    ],
    "mobileImages": [
      "/images/Robbie-9x16/JJG00147.jpg",
      "/images/Robbie-9x16/JJG00184.jpg",
      "/images/Robbie-9x16/JJG00324.jpg",
      "/images/Robbie-9x16/JJG00374.webp",
      "/images/Robbie-9x16/JJG00436-2.jpg"
    ]
  },
  {
    "id": "ice-show",
    "title": "HOLIDAY ON ICE",
    "videoPlaybackId": "Fgou6D7x1dHM6kZLN2yTxtl400wKB00thVZZJjCB1dGTs",
    "videoTitle": "Holiday On Ice",
    "detailHeading": "Holiday On Ice",
    "paragraphs": [
      "At Grefrather EisSport & Event Park in Germany, I filmed Holiday On Ice - Cinema of Dreams. ",
      "Across both video and photography, I focused on capturing the high energy of the skaters, using two main focal lengths (24mm and 100mm). "
    ],
    "images": [
      "/images/Slides-Ice/Untitled-23.webp",
      "/images/Slides-Ice/Untitled-32.webp",
      "/images/Slides-Ice/Untitled-46.webp",
      "/images/Slides-Ice/Untitled-50.webp",
      "/images/Slides-Ice/Untitled-54.webp",
      "/images/Slides-Ice/Untitled-62.webp",
      "/images/Slides-Ice/Untitled-84.webp",
      "/images/Slides-Ice/Untitled-95.webp",
      "/images/Slides-Ice/Untitled-96.webp",
      "/images/Slides-Ice/Untitled-104.webp",
      "/images/Slides-Ice/Untitled-105.webp",
      "/images/Slides-Ice/Untitled-106.webp"
    ],
    "mobileImages": [
      "/images/Ice-show-6x19/JJG00001.webp",
      "/images/Ice-show-6x19/JJG00086.webp",
      "/images/Ice-show-6x19/JJG00157.webp",
      "/images/Ice-show-6x19/JJG00692.webp"
    ]
  },
  {
    "id": "drumsheds",
    "title": "DRUMSHEDS",
    "videoPlaybackId": "z01t1kBQHJ3R902nVAFUWGv8UaVmefIxEGd7e4d01iiQRM",
    "videoTitle": "DRUMSHEDS",
    "detailHeading": "ANTS x DRUMCODE",
    "paragraphs": [
      "I produced high energy social media reels at Drumsheds, capturing performances and crowd atmosphere for leading electronic artists. Delivered content for talent including Tini Gessler, with work featured on her official TikTok, driving audience engagement and extending event reach across platforms."
    ],
    "images": [
      "/images/drumsheds/JJG00884-2.jpg",
      "/images/drumsheds/JJG00070.jpg",
      "/images/drumsheds/JJG00661.jpg",
      "/images/drumsheds/JJG00769.jpg",
      "/images/drumsheds/JJG00166-2.jpg"
    ],
    "mobileImages": [
      "/images/drumsheds/JJG00166-2.jpg"
    ]
  }
];

export default PROJECTS;
